export default (items, search, size) => {
	if (search.trim().length === 0) return [items, [], false];
	const s = search.toLowerCase().replace(/,/g, ' ').replace(/  +/g, ' ');
	let searchKeys = s.split(' ');
	let counter = 0;
	let fastEnd = false;

	const match = (x) => {
		const publicCode = x.publicCode.toLowerCase();
		const name = x.name.toLowerCase().replace(/,/g, ' ').replace(/  +/g, ' ');
		const fullName = publicCode + ' ' + name;

		return searchKeys.every(k => k === '' || fullName.includes(k))
	}

	const find = (object) => {
		let filteredChildrens = [];
		if (object.children && object.children.length > 0) {
			object.children.forEach((element) => {
				if (counter > size) {
					fastEnd = true;
					return;
				}
				const findEl = find(element);
				if (findEl !== null) {
					filteredChildrens.push(findEl);
					counter += 1;
				}
			})
		}
		if (filteredChildrens.length > 0) {
			counter += 1;
			return {
				...object,
				shouldOpen: true,
				children: filteredChildrens
			}
		}

		if (counter > size) {
			fastEnd = true
			return null
		}
		const isMatch = match(object);
		if (isMatch) return object;

		return null;
	}
	const newItems = items.reduce((prev, curr) => {
		const el = find(curr);
		if (el === null) return prev;
		return [
			...prev,
			el,
		]
	}, [])
	return [newItems, searchKeys, fastEnd]
}